import React from "react";
import { TextField } from "@mui/material";
import { Filter, InputChange } from "./datafilter-types";

interface DefaultFilterProps {
  filter: Filter;
  onChangeString: (name: string, ev: InputChange) => void;
}

const DefaultFilter: (props: DefaultFilterProps) => JSX.Element = ({
  filter,
  onChangeString,
}) => {
  const { name, placeholder, value } = filter;
  return (
    <TextField
      aria-label={placeholder}
      inputProps={{
        "data-testid": `${name}-input`,
      }}
      onChange={(ev) => {
        onChangeString(name, ev);
      }}
      label={placeholder}
      value={value}
    />
  );
};

export default DefaultFilter;
